/** Shared ref for auth session outside React tree (ApiController, UtilContext, Locale sync). */
export const PassLogoutProvider = {
  user: null,
  setUser: () => {},
  logout: () => {},
};
